<div
  contenteditable
  [numberInput]="numberValue"
  [allowNegatives]="allowNegatives"
  (valueChange)="onValueChange($event)"
  appFormatInputMoneyContentEditable
  class="outline-0 outline-none editable-input-div"
  [ngClass]="{ 'disabled p-disable': disabled, negative: numberValue < 0, positive: numberValue > 0 }"
></div>
